import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import Post1 from "../../assets/images/In-Room-Dining/Restaurant-2.png";
import Dine1 from "../../assets/images/In-Room-Dining/Post-1.png";
import Dine2 from "../../assets/images/In-Room-Dining/Post-2.png";
import Dine3 from "../../assets/images/In-Room-Dining/Post-3.png";
import Dine4 from "../../assets/images/In-Room-Dining/Post-4.png";
import Dine5 from "../../assets/images/In-Room-Dining/Post-5.png";
import Dine6 from "../../assets/images/In-Room-Dining/Post-6.png";
import Dine7 from "../../assets/images/In-Room-Dining/Post-7.png";
import Dine8 from "../../assets/images/In-Room-Dining/Post-8.png";
import Carosle from "../../Components/Carosle";
import axios from "../../axios";
import CarRentalLoader from "../../Components/Loaders/CarRentalLoader";
import {
  ShowRestaurantCategories,
  ShowRestaurantSubCategories,
} from "../../API/In-Room-DiningAPI";
import Search from "../../Components/Search";
import { Fade, Zoom } from "react-reveal";
import HeaderInnerInDining from "../../Components/HeaderInnerInDining";
import BannerHome from "../../new-components/banner-home/BannerHome";
import { ThemeContext } from "../../context/ThemeContext";

function InDiningSubCat() {
  const [enableClass, setEnableClass] = useState(true);
  // const [restaurantCategories, setRestaurantCategories] = useState();
  const [loading, setLoading] = useState(false);
  // const [bgColor, setBgColor] = useState();
  // const [color, setColor] = useState();
  const [nameHeader, setHeaderName] = useState();
  // const [images, setImages] = useState();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const params = useParams();
  const navigate = useNavigate();
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  // console.log(params);
  // setTimeout(() => {
  //   setEnableClass(false);

  let isbooking = rawPath.includes("RestaurantBooking");
  // console.log("rawPath", rawPath.includes("ResteaurantBooking"));
  // }, 3000);
  const type = localStorage.getItem("type")

  let hideIcon = false
  const lang = sessionStorage.getItem("lang");
  let restaurant;
  let restaurantCategories;
  let images = [];
  let isVideo = false;
  let bgColor;
  let color;
  let text;
  let restaurant_info;
  let terms_and_conditions;
  const { data, isLoading, error } = ShowRestaurantSubCategories(
    room_uuid,
    params.id,
    lang,
    params.cat_id,
    (isbooking = isbooking ? "&link_type=menu" : "")
  );

  if (!isLoading) {
    if (data.data.status == false) {
      navigate(`/${room_uuid}/qr-scan`);
    } else if (!error) {
      restaurant = data.data.data;
      restaurantCategories = restaurant.categories;
      // setHeaderName=restaurant.center_header;
      // let restaurant_images = [...restaurant.restaurant?.images]
      // isVideo = false;
      // images = restaurant.banners;
      isVideo = restaurant.restaurant.real_video ? true : false;
      terms_and_conditions = restaurant.restaurant.terms_and_conditions;


      if (restaurant.restaurant.real_video) {
        if (restaurant.banners?.length > 0) {
          images = [
            { image: restaurant.restaurant.real_video },
            ...restaurant?.banners,
          ];
        }
      } else {
        if (restaurant.banners?.length > 0) {
          images = restaurant?.banners;
        }
      }
      // console.log("imagesimagesimages", images);
      color = data.data.data.color;
      bgColor = data.data.data.header_color;
      text = data.data.data.center_header;
      restaurant_info = restaurant.restaurant;

      if (type == "in_dining") {
        if (restaurant_info?.can_order == false) {
          hideIcon = true
        }
      }

      if (restaurantCategories?.length == 1) {
        if (restaurantCategories[0]?.count_sub_categories != 0) {
          navigate(
            `/${room_uuid}/rstauran-menu-subcategories/${params.id}/${restaurantCategories[0].id}`,
            { replace: true }
          );
        } else {
          navigate(
            `/${room_uuid}/rstauran-menu-items/${params.id}/${restaurantCategories[0].id}`,
            { replace: true }
          );
        }
      }

      console.log("restaurant_imagesrestaurant_images", images);
      window.scrollTo({
        top: 0,
        left: 0,
      });
    }
  }

  // useEffect(() => {
  //   const getData = async () => {
  //     setLoading(true)
  //     axios
  //       .get(`/${room_uuid}/restaurant/categories/${params.id}`)
  //       .then((res) => {
  //         const data = res.data.data;
  //         setRestaurantCategories(data.categories);
  //         setHeaderName(data.center_header);
  //         setBgColor(data.header_color);
  //         setColor(data.color);
  //         setImages(data.restaurant?.images)
  //         setLoading(false)

  //       });
  //   };
  //   getData();
  // }, []);
  // console.log('imags', images);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);
  const imageref = useRef();
  const [height_res, setheight_res] = useState();
  useEffect(() => {
    console.log("imageref00");
    if (imageref.current) {
      setheight_res(imageref.current.clientWidth);
      console.log("imageref", imageref.current.clientWidth);
    }
  }, [data]);
  return (
    isLoading ?
      <CarRentalLoader /> :
      <div className={theme ? "food" : ""}>
        <HeaderInnerInDining bgColor={bgColor} color={color} theme={theme} hideIcon={hideIcon} />
        <main className="bg-white pad-top-0 resturant_category">



          <>
            {images?.length > 0 &&
              (theme ? (
                <>
                  <BannerHome
                    // className={"px-2"}
                    className={"bot_rad"}
                    headerImages={images}
                    isOverllay={true}
                    isVideo={isVideo}
                  />
                  <div className={`res_info ${images?.length == 0 ? "mt-0" : ""}`}>
                    {" "}
                    <div className="res_name">
                      <h5 className="">
                        {" "}
                        {lang == "EN"
                          ? restaurant_info.display_name
                          : restaurant_info.name}
                      </h5>
                      <p>
                        {restaurant_info?.cuisines?.map((cuisine, idx) => {
                          if (idx + 1 < restaurant_info?.cuisines.length) {
                            return `${cuisine.name}  |  `;
                          } else {
                            return `${cuisine.name}  `;
                          }
                        })}
                      </p>
                    </div>
                    {/* {restaurant_info?.show_booking == 1 && (
                <button
                  onClick={() =>
                    navigate(
                      `/${params.room_uuid}/BookTable/${restaurant_info.uuid}/${restaurant_info.id}?theme=true`
                    )
                  }
                  className="reg-btn"
                >
                  Book a Table
                </button>
              )} */}
                  </div>
                </>
              ) : (
                <header className="img-header m-0 pt-0">
                  <Carosle headerImages={images} isVideo={isVideo} />
                </header>
              ))}

            {/* <div className="Search-bar less mt-4">
              <input
                className="form-control"
                type="search"
                placeholder="Search for Dishes, Drinks ... "
                disabled
              />
              <i class="fa fa-search" aria-hidden="true"></i>
            </div> */}
            <Search
              placeholder="Search for Categories..."
              room_uuid={room_uuid}
              category="Restaurant&in_dining"
            />
            {terms_and_conditions != "" &&
              (terms_and_conditions != undefined ? (
                <>
                  {/* <p className="text-center">Terms & Conditions</p> */}
                  <div
                    className="mx-4 divhtml"
                    dangerouslySetInnerHTML={{
                      __html: terms_and_conditions,
                    }}
                  />
                </>
              ) : null)}
            <ul
              className={`${restaurant_info?.squared_categories == 1 ? "res_sp" : ""
                }  display-list two-items restaurant-list mt-2 v2 ${restaurant_info?.resturant_name.includes("McDonald")
                  ? "mcdonald"
                  : ""
                } `}
            >
              {restaurantCategories
                ? restaurantCategories.map((category) => {
                  return (
                    <Zoom>
                      <li
                        className={
                          category?.is_closed
                            ? "closed restaurant-option"
                            : "restaurant-option"
                        }
                      >
                        <Link
                          to={
                            category.count_sub_categories != 0
                              ? `/${room_uuid}/rstauran-menu-subcategories/${params.id}/${category.id}`
                              : `/${room_uuid}/rstauran-menu-items/${params.id}/${category.id}`
                          }
                          ref={imageref}
                          style={
                            restaurant_info?.squared_categories == 1
                              ? { height: `${height_res}px` }
                              : { height: `140px` }
                          }
                        >
                          <div className="closed-tag"></div> <div></div>
                          {category?.is_closed && (
                            <span className="open_at">
                              {category.opens_at
                                ? `Opens at ${category.opens_at}`
                                : `Closed`}
                            </span>
                          )}
                          <div
                            className="img-pnl"
                          // style={{
                          //   backgroundImage: `url(${category.image})`,
                          // }}
                          >
                            <img src={encodeURI(category.image)} alt="" />
                          </div>
                          {/* {console.log(category.image.replace(/ /g, "%20"))} */}
                          <div className="bg-layer"></div>
                          <p>{category.name}</p>
                        </Link>
                      </li>
                    </Zoom>
                  );
                })
                : null}
            </ul>
          </>

        </main>
      </div>
  );
}
export default InDiningSubCat;
